import React from 'react';
import Badge from '@mui/material/Badge';

const IconWithText = ({ text, icon }) => (
  <Badge
    badgeContent={text}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    sx={{
      '& .MuiBadge-badge': {
        transform: 'scale(1) translate(20%, 50%)',
        fontSize: '0.65rem',
      },
    }}
  >
    {icon}
  </Badge>
);

export default IconWithText;
